import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify: new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#1565C0',
          secondary: '#455A64',
          accent: '#FF8F00',
          success: '#2E7D32',
          error: '#C62828'
        }
      }
    }
  }),
  render: h => h(App)
}).$mount('#app')
